import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import PageBanner from "../layout/PageBanner";
import { catalogService } from "../services";
import { Panel, Skeleton } from "../components/ui";

export default function About() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.about().then((data) => alive && setContent(data));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <Layout>
      <PageBanner title="เกี่ยวกับเรา" breadcrumb={[{ label: "เกี่ยวกับ" }]} seed={8} />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel>
          {!content ? (
            <Skeleton height={320} />
          ) : (
            <>
              <h2 className="lt-panel__title">{content.title}</h2>
              <p className="lt-article" style={{ lineHeight: 1.9 }}>
                {content.intro}
              </p>

              <div className="lt-grid-2 lt-mt-24">
                {content.points.map((point) => (
                  <div
                    key={point.title}
                    style={{ border: "1px solid var(--lt-line)", borderRadius: 14, padding: 18, marginBottom: 18 }}
                  >
                    <strong>{point.title}</strong>
                    <p className="lt-helper lt-mb-0" style={{ marginTop: 6 }}>
                      {point.detail}
                    </p>
                  </div>
                ))}
              </div>
            </>
          )}
        </Panel>
      </div>
    </Layout>
  );
}
